import { useEffect } from 'react';

import { useFindCustomerByEmailInputModal } from '~/components/Customer/Modals/FindCustomerByEmail';
import { PageContainer } from '~/components/Page/Page.Container';

// Finding a customer is entirely modal driven - this route only exists so the
// drawer entry has a screen to hang off, and opens the same modal if reached.
export const FindCustomerByEmailScreen = () => {
  const { open } = useFindCustomerByEmailInputModal();

  useEffect(() => {
    open();
  }, []);

  return <PageContainer />;
};
